import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';
import { cryptoTokenDecode } from "../components/Common/Common";

/**
 *  
 * @desc Api call for get admin matser teampaltes
 */
export function adminGetMaterTemplateAction() {  
    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.AdminGetMaterTemplateUrl,true).then(response => {

          if(response.status === code.OK) {
              dispatch( {
                    type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
                    adminMasterTemplates: response.data.data,
                    totalAdminTemplates : response.data.total
              });
          }
          else {
              dispatch( {
                  type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
                  adminMasterTemplates: {},
                  totalAdminTemplates : 0
              });
          }
      });
    }  
}
/**
 *  
 * @desc API call to get dependency task
 */
export function GetDependencytasksAction(campaign, day, event, module) {
    let url = '';
    return function (dispatch){
        if(module == 'ADMIN'){
            url = `${UrlConstants.setDependency}campaign=${campaign}&day=${day}&eventId=${event}&isTransaction=false`
        }
        if(module == 'USER'){
            url = `${UrlConstants.setDependency}campaign=${campaign}&day=${day}&eventId=${event}`
        }
        if(module == 'TRANSACTION'){
            url = `${UrlConstants.setDependency}day=${day}&transactionId=${campaign}&eventId=${event}`
        }
      return APIUtil.getMethod(url ,true).then(response => {
          if(response.status === code.OK) {
              dispatch( {
                    type: types.GET_DEPENDENCY_DATA,
                    dependencyTasks: response.data,
              });
          }
          else {
              dispatch( {
                  type: types.GET_DEPENDENCY_DATA,
                  dependencyTasks: {}
              });
          }
          return response;
      });
    }  
}
/**
 *  
 * @desc API call for update dependent tasks 
 */
export function putDependencytasksAction(event, module, apidata) {
    let url = '';
    return function (dispatch){
        if(module == 'ADMIN'){
            url = `${UrlConstants.setDependency}eventId=${event}&isTransaction=false`
        }
        if(module == 'BUYERAGENT'){
            url = `${UrlConstants.setDependency}eventId=${event}`
        }
        if(module == 'ACCTOWNER'){
            url = `${UrlConstants.setDependency}eventId=${event}`
        }
        if(module == 'TRANSACTION'){
            url = `${UrlConstants.setDependency}eventId=${event}&isTransaction=true`
        }
      return APIUtil.putMethod(url ,apidata, true).then(response => {
          if(response.status === code.OK) {
              dispatch( {
                    type: types.PUT_DEPENDENCY_DATA,
                    dependencyTasks: response,
                    status: true,
                    statusMessage: 'Dependencies Added Successfully',
              });
          }
          else {
              dispatch( {
                  type: types.PUT_DEPENDENCY_DATA,
                  dependencyTasks: {},
                  status: false,
                  statusMessage: 'Something went Wrong',
              });
          }
          return response;
      });
    }  
}
/**
 * 
 * @desc Update master template data API call
 */
export function adminUpdateMaterTemplateAction(data,model,campaignId, eventTempId, commuId, type) {  

    var url = UrlConstants.AdminUpdateBothMaterTemplateUrl;
    if(model === "campaign") {
        url = UrlConstants.AdminUpdateCampMaterTemplateUrl.replace("{model}",model);
        url = url.replace("{campaignId}",campaignId)
    }

    if(model === "both") {
        url = UrlConstants.AdminUpdateBothMaterTemplateUrl.replace("{eventTempId}",eventTempId);
        if(type === 0) {
            url = url.replace("{commuId}",commuId)
        } else {
            //remove commuid from url
            url = url.replace("&communicationtemplateId={commuId}",'')
        }
        
    }

    return function (dispatch){
      return APIUtil.putMethod(url,data,true).then(response => {
        
          if(response.status === code.OK) {
              dispatch( {
                    type: types.ADMIN_UPDATE_MASTER_TEMPLATE_DATA,
                    isMasterTemplateUpdated : true,
                    updatedEventData : response.data
              });
              return response.data;
          }
          else {
              dispatch( {
                  type: types.ADMIN_UPDATE_MASTER_TEMPLATE_DATA,
                  isMasterTemplateUpdated : false,
                  updatedEventData : []
              });
              return response.data;
          }
      });
    }  
}

/**
 * 
 * @desc Update master template data API call
 */
export function adminCreatEventCommMaterTemplateAction(data) {  
    return function (dispatch){
      return APIUtil.postMethod(UrlConstants.AdminCreatEventCommMaterTemplateUrl,data,true).then(response => {
        
          if(response.status === code.OK) {
              dispatch( {
                    type: types.CREATE_EVENT_COMM_MASTER_TEMPLATE,
                    isEventCommCreated : true,
                    addedEventComm : response.data
              });
          }
          else {
              dispatch( {
                  type: types.CREATE_EVENT_COMM_MASTER_TEMPLATE,
                  isEventCommCreated : false,
                  addedEventComm : []
              });
          }
      });
    }  
}


/**
 * 
 * @desc Get list of variables - variables contains all tokens for replacement
 */
export function adminGetVarriableRefAction() {  
    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.AdminGetVarriableRefMaterTemplateUrl,true).then(response => {
          if(response.status === code.OK) {
              dispatch( {
                    type: types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF,
                    variablesRefs : response.data
              });
              return response.data
          }
          else {
              dispatch( {
                  type: types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF,
                  variablesRefs : []
              });
              return []
          }
      });
    }  
}

/**
 * 
 * @desc Get list of variables - variables contains all tokens for replacement
 */
 export function adminGetVariableRefAction(campaignId) {  
    var url = UrlConstants.AdminGetVariableRefMaterTemplateUrl;
  
        url = url.replace("{systemCampaignStyleId}",campaignId)
    
    return function (dispatch){
      return APIUtil.getMethod(url,true).then(response => {
          if(response.status === code.OK) {
              dispatch( {
                    type: types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF,
                    variablesRefs : response.data
              });
              return response.data
          }
          else {
              dispatch( {
                  type: types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF,
                  variablesRefs : []
              });
              return []
          }
      });
    }  
}
/**
 * 
 * @desc Delete Communication template
 */
export function adminDelEventCommunicationAction(eventtemplateId) {  
    return function (dispatch){

        var url = UrlConstants.AdminDeleteEventCommMaterTemplateUrl.replace("{eventtemplateId}",eventtemplateId);
        return APIUtil.deleteMethod(url,true).then(response => {
          if(response.status === code.OK) {
              dispatch( {
                    type: types.DELETE_EVENT_COMM_MASTER_TEMPLATE,
                    isMasterTemplateTaskDeleted: true,
              });
          }
          else {
              dispatch( {
                  type: types.DELETE_EVENT_COMM_MASTER_TEMPLATE,
                  isMasterTemplateTaskDeleted: false,
              });
          }
        });
    }  
}


/**
 * 
 * @desc Get campaign data by campaign id - api call
 */
export function adminGetCampDataByIdAction(id) {  

    let url = UrlConstants.AdminGetCampDataByIdMaterTemplateUrl;
    url = url.replace("{campId}",id);
    return function (dispatch){
      return APIUtil.getMethod(url,true).then(response => {
          if(response.status === code.OK) {
              dispatch( {
                    type: types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID,
                    campDataById : response.data.data,
              });
          }
          else {
              dispatch( {
                  type: types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID,
                  campDataById : []
              });
          }
      });
    }  
}


/**
 * 
 * @desc Admin : Create campaign
 */
export function adminCreatCampaignMaterTemplateAction(data) {  
    return function (dispatch){
      return APIUtil.postMethod(UrlConstants.AdminCreatCampaignMaterTemplateUrl,data,true).then(response => {
        
          if(response.status === code.OK) {
              dispatch( {
                    type: types.CREATE_CAMPAIGN_MASTER_TEMPLATE,
                    isCampaignCreated : true,
                    addedCampaign : response.data
              });
          }
          else {
              dispatch( {
                  type: types.CREATE_CAMPAIGN_MASTER_TEMPLATE,
                  isCampaignCreated : false,
                  addedCampaign : []
              });
          }
          return response;
      });
    }  
}


/**
 * 
 * @desc Admin : Copy campaign
 */
export function adminCopyCampaignMaterTemplateAction(data) {  
    let userType = cryptoTokenDecode().usertype;
    if (userType === "VENDOR") {
        data.ownerId = localStorage.getItem("ownerId");
    }
    return function (dispatch){
      return APIUtil.postMethod(UrlConstants.AdminCopyCampaignMaterTemplateUrl,data,true).then(response => {
        
          if(response.status === code.OK) {
              dispatch( {
                    type: types.COPY_CAMPAIGN_MASTER_TEMPLATE,
                    isCampaignCreated : true,
                    addedCampaign : response.data
              });
          }
          else {
              dispatch( {
                  type: types.COPY_CAMPAIGN_MASTER_TEMPLATE,
                  isCampaignCreated : false,
                  addedCampaign : []
              });
          }
          return response;
      });
    }  
}

/**
 * 
 * @desc Admin : Get contingecies
 */
export function adminGetContigencyAction() {  
    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.AdminGetContingencyUrl,true).then(response => {
        
          if(response.status === code.OK) {
              dispatch( {
                    type: types.GET_CONTINGENCIES,
                    contingencies : response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_CONTINGENCIES,
                  contingencies : []
              });
          }
      });
    }  
}


/**
 * 
 * @desc Admin : Get contingecies
 */
export function getAllContigencyAction() {  
    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.allContingencies,true).then(response => {
        
          if(response.status === code.OK) {
              dispatch( {
                    type: types.GET_ALL_CONTINGENCIES,
                    allContingencies : response.data
              });
              return response.data
          }
          else {
              dispatch( {
                  type: types.GET_ALL_CONTINGENCIES,
                  allContingencies : []
              });
              return []
          }
          
      });
    }  
}


/**
 * 
 * @desc Update Dependant tasks after confirmation
 */
export function adminUpdateDependentTasksAction(data,model,campaignId, eventTempId, commuId, type) {  
    return function (dispatch){
      return APIUtil.putMethod(UrlConstants.uploadDependentTaskURL + eventTempId, data, true).then(response => {
        
          if(response.status === code.OK) {
              dispatch( {
                    type: types.UPDATE_DEPENDENT_TASKS
              });
              return response.data;
          }
          else {
              dispatch( {
                  type: types.UPDATE_DEPENDENT_TASKS,
              });
              return response;
          }
      });
    }  
}

/**
 *  
 * @desc List dependency Tasks API call
 */
export function deleteDependencytasksAction(event, module, apidata) {
    let url = '';
    return function (dispatch){
        if(module == 'ADMIN'){
            url = `${UrlConstants.setDependency}id=${event}&isTransaction=false&removeId=${apidata}`
        }
        if(module == 'BUYERAGENT'){
            url = `${UrlConstants.setDependency}id=${event}&removeId=${apidata}`
        }
        if(module == 'ACCTOWNER'){
            url = `${UrlConstants.setDependency}id=${event}&removeId=${apidata}`
        }
        if(module == 'TRANSACTION'){
            url = `${UrlConstants.setDependency}id=${event}&isTransaction=true&removeId=${apidata}`
        }
      return APIUtil.deleteMethod(url, true).then(response => {
          if(response.status === code.OK) {
              dispatch( {
                    type: types.PUT_DEPENDENCY_DATA,
                    dependencyTasks: response,
                    status: true,
                    statusMessage: 'Dependencies Removed Successfully',
              });
          }
          else {
              dispatch( {
                  type: types.PUT_DEPENDENCY_DATA,
                  dependencyTasks: {},
                  status: false,
                  statusMessage: 'Something went Wrong',
              });
          }
          return response;
      });
    }  
}

export function deleteSystemCampaignListAction(data) {
    let url = UrlConstants.deleteSystemCampaignUrl + '/' + data.id;

    return function (dispatch) {
        return APIUtil.putMethod(url, data, true).then(response => {
            dispatch( {
                type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
                adminMasterTemplates: response.status === code.OK ? response.data.data : {},
                totalAdminTemplates : response.status === code.OK ? response.data.total : 0
            });
            return response;
        });
    }
}

/**
 * find vendor company
 * 17-5-2023
 */
export function grtAllCompanylistbyVendorId() {
    let usertype = cryptoTokenDecode().usertype;
    let id = cryptoTokenDecode()._id;
    let url =
      UrlConstants.Getcompanylist + "?userId=" + id + "&userType=" + usertype;
    return function(dispatch) {
      return APIUtil.getMethod(url, true).then((response) => {
        if (response.status === code.OK) {
          return response;
        } else {
          let emptyarray = [];
          return emptyarray;
        }
      });
    };
  }


  /**
 *  
 * @desc Api call for get admin quick appointment template
 */
export function adminGetQuickAppointmentTemplateAction() {  
    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.getQuickAppointmentUrl,true).then(response => {

          if(response.status === code.OK) {
              dispatch( {
                    type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
                    adminMasterTemplates: response.data.data,
                    totalAdminTemplates : response.data.total
              });
          }
          else {
              dispatch( {
                  type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
                  adminMasterTemplates: {},
                  totalAdminTemplates : 0
              });
          }
          return response;
      });
    }  
}
